/* import Vue from 'vue'; */
import Env from './env';
import { getDeviceInfo, getUserUUIDInfo } from './error';

/* eslint-disable */

/* 微信里设置标题 */
export function setMetaTitle (title) {
	document.title = title;
	const mobile = navigator.userAgent.toLowerCase();
	if (/iphone|ipad|ipod/.test(mobile)) {
		const iframe = document.createElement('iframe');
		iframe.style.display = 'none';
		// 替换成站标favicon路径或者任意存在的较小的图片即可
		iframe.setAttribute('src', 'public/favicon.ico');
		const iframeCallback = () => {
			setTimeout(() => {
				iframe.removeEventListener('load', iframeCallback);
				document.body.removeChild(iframe);
			}, 0);
		};
		iframe.addEventListener('load', iframeCallback);
		document.body.appendChild(iframe);
	}
}

/* 是否合法手机号 */
export function isValidMobile (val) {
	return /^(?=\d{11}$)^1(?:3[0-9]|4[0-9]|5[0-9]|66|7[0-9]|8[0-9]|9[0-9])\d{8}$/.test(val);
}

/* 设备内生成唯一id */
export function guid () {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
		const r = (Math.random() * 16) | 0;
		const v = c === 'x' ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
}

export function getCookie (name) {
	const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
	const arr = document.cookie.match(reg);
	if (arr) {
		return unescape(arr[2]);
	}
	return null;
}

export function setCookie (name, value, expireSeconds = 60 * 60 * 24 * 30, domain) {
	let cookieString = name + '=' + escape(value),
		date = new Date()
	date.setTime(date.getTime() + expireSeconds * 1000)
	if (domain) cookieString += '; domain=' + domain
	document.cookie = cookieString + '; path=/; expires=' + date.toGMTString()
}

/* 路由变化 自动隐藏提示框 */
export function hideMessageBox () {
	const messageELe = document.getElementsByClassName('v-modal');
	if (messageELe.length) {
		messageELe[0].click();
	}
}

/* ios半屏 */
export function isIosHalfWebview () {
	if (Env.isIOS) {
		const {
			body: { clientWidth, clientHeight },
		} = document;
		const {
			screen: { height },
		} = window;
		return (
			Number(clientWidth) === 300 || Number(clientHeight) / Number(height) < 0.7
		);
	}
	return false;
}


/* 字符串转16进制 */
export function strToHexCharCode (str) {
	if (str === "") {
		return "";
	}
	const hexCharCode = ["0x"];
	for (let i = 0; i < str.length; i += 1) {
		hexCharCode.push(str.charCodeAt(i).toString(16));
	}
	return hexCharCode.join("");
}

/* 16进制转字符串 */
export function hexCharCodeToStr (hexCharCodeStr) {
	const trimedStr = hexCharCodeStr.trim();
	const rawStr =
		trimedStr.substr(0, 2).toLowerCase() === "0x"
			? trimedStr.substr(2)
			: trimedStr;
	const len = rawStr.length;
	if (len % 2 !== 0) {
		return "";
	}
	let curCharCode;
	const resultStr = [];
	for (let i = 0; i < len; i += 2) {
		curCharCode = parseInt(rawStr.substr(i, 2), 16); // ASCII Code Value
		resultStr.push(String.fromCharCode(curCharCode));
	}
	return resultStr.join("");
}


// 解码
export function decodeUnicode (str) {
	str = str.replace(/\\/g, "%");
	//转换中文
	str = unescape(str);
	//将其他受影响的转换回原来
	str = str.replace(/%/g, "\\");
	//对网址的链接进行处理
	str = str.replace(/\\/g, "");
	return str;
}

export function getQueryParams (link) {
	let url = '';
	const href = decodeURI(link || window.location.href)
	if (href.indexOf('?') !== -1) {
		url = href.split('?')[1];
	} else {
		url = href
	}
	const obj = {};
	if (url) {
		const strs = url.split('&');
		for (let i = 0; i < strs.length; i += 1) {
			obj[strs[i].split('=')[0]] = strs[i].split('=')[1];
		}
	}
	return obj;
}


function urlEncode (param, key, encode) {
	if (param == null) return '';
	var paramStr = '';
	var t = typeof (param);
	if (t == 'string' || t == 'number' || t == 'boolean') {
		paramStr += '&' + key + '=' + ((encode == null || encode) ? encodeURIComponent(param) : param);
	} else {
		for (var i in param) {
			var k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '' + i)
			paramStr += urlEncode(param[i], k, encode)
		}
	}
	return paramStr;

}

export async function getQueryFromDuiBa () {
	const info = await getDeviceInfo();
	const MgtvUserInfo = await getUserUUIDInfo();
	const data = {
		uuid: MgtvUserInfo.uuid,
		ticket: MgtvUserInfo.ticket,
		redirect: 'http://activity.m.duiba.com.cn/crecord/record?from=login&spm=46614.1.1.1',
		did: info.imei || info.idfa || '',
		device: info.device || '',
		appVersion: info.appVersion || '',
		osType: info.osType || '',
		platform: 'iphone',
		abroad: info.abroad || '',
	}
	let urlParams = urlEncode(data, '', false);
	return urlParams.slice(1)
}
/**
 * desc 生成 uuid4
 * @returns {string}
 * @private
 */
export function genUUID4 () {
	let r = Math.random,
		p = '0000000',
		n = 0x100000000,
		a = ((r() * n) >>> 0).toString(16),
		b = ((((r() * n) & 0xffff4fff) | 0x4000) >>> 0).toString(16),
		c = ((((r() * n) & 0xbfffffff) | 0x80000000) >>> 0).toString(16),
		d = ((r() * n) >>> 0).toString(16)

	if (a.length < 8) {
		a = (p + a).slice(-8)
	}
	if (b.length < 8) {
		b = (p + b).slice(-8)
	}
	if (c.length < 8) {
		c = (p + c).slice(-8)
	}
	if (d.length < 8) {
		d = (p + d).slice(-8)
	}

	return [a, b.slice(0, 4), b.slice(4), c.slice(0, 4), c.slice(4) + d].join('-')
}
/**
 * 生成STKUUID,设备id(大数据did)
 * @method {{getSTKUUID}}
 * @return {[type]} [description]
 */
export function getSTKUUID () {
	let uuid = this.getCookie('__STKUUID')
	if (uuid == '') {
		uuid = this.genUUID4()
		if (location.host.search('.mgtv.com') != -1) {
			this.setCookie('__STKUUID', uuid, 9000, '.mgtv.com')
		} else {
			this.setCookie('__STKUUID', uuid, 9000)
		}
	}
	return uuid
}